module.exports = __webpack_public_path__ + "fonts/iconfont.9bc42dc3.ttf";